<template>
  <svg :style="style" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Frame" clip-path="url(#clip0_3654_43814)">
<path id="Vector" d="M25.1973 2.96626C24.653 2.38001 23.7973 2.15951 22.98 2.08076C22.1225 1.99851 21.0935 2.05276 19.9875 2.19801C17.7685 2.48851 15.0875 3.16226 12.5098 3.99176C9.93201 4.82126 7.41901 5.82051 5.53776 6.77601C4.60151 7.25201 3.78776 7.73501 3.19801 8.19701C2.91387 8.41172 2.65757 8.66097 2.43501 8.93901C2.24251 9.19101 2.03951 9.55151 2.04301 9.98201C2.05001 11.116 2.82176 11.9175 3.64426 12.4548C4.48426 13.0043 5.57801 13.4173 6.66476 13.7428C7.76201 14.07 8.91876 14.3238 9.91101 14.5303L10.2663 14.6038C10.8665 14.7263 11.1658 14.7893 11.4493 14.7053C11.7293 14.6195 11.948 14.4025 12.382 13.9703L16.6765 9.67576C16.8987 9.4756 17.1892 9.36835 17.4882 9.37614C17.7871 9.38393 18.0717 9.50617 18.2831 9.71763C18.4946 9.92909 18.6168 10.2136 18.6246 10.5126C18.6324 10.8115 18.5252 11.1021 18.325 11.3243L14.321 15.33C13.8783 15.7728 13.656 15.9933 13.5738 16.2803C13.4898 16.5673 13.5563 16.8718 13.6928 17.4808C14.216 19.8433 14.671 21.7945 15.1243 23.1088C15.3868 23.8753 15.686 24.5403 16.064 25.0285C16.456 25.5395 16.9915 25.9263 17.6968 25.956C18.1343 25.977 18.5018 25.7758 18.7503 25.5903C19.0145 25.3943 19.263 25.1318 19.4923 24.8448C19.9543 24.2673 20.439 23.4693 20.922 22.5453C21.8933 20.6903 22.9205 18.2035 23.792 15.645C24.66 13.0865 25.3845 10.4195 25.7345 8.20226C25.9078 7.09626 25.9935 6.06901 25.9445 5.20976C25.9008 4.39251 25.7275 3.53676 25.1973 2.96626Z" fill="url(#paint0_linear_3654_43814)"/>
</g>
<defs>
<linearGradient id="paint0_linear_3654_43814" x1="2.04297" y1="13.9999" x2="25.9582" y2="13.9999" gradientUnits="userSpaceOnUse">
<stop stop-color="#376EFF"/>
<stop offset="1" stop-color="#DE5DFE"/>
</linearGradient>
<clipPath id="clip0_3654_43814">
<rect width="28" height="28" fill="white"/>
</clipPath>
</defs>
</svg>
</template>

<script>
export default {
  name: 'send',
  props: {
    fontSize: {
      type: String,
      default: '24px'
    }
  },
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        'font-size': this.fontSize
      }
    }
  }
}
</script>